/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Sync200ResponseOneOf1ShiftsLastDay
 */
export interface Sync200ResponseOneOf1ShiftsLastDay {
    /**
     * 
     * @type {string}
     * @memberof Sync200ResponseOneOf1ShiftsLastDay
     */
    start: string | null;
    /**
     * 
     * @type {string}
     * @memberof Sync200ResponseOneOf1ShiftsLastDay
     */
    end: string | null;
}

/**
 * Check if a given object implements the Sync200ResponseOneOf1ShiftsLastDay interface.
 */
export function instanceOfSync200ResponseOneOf1ShiftsLastDay(value: object): value is Sync200ResponseOneOf1ShiftsLastDay {
    if (!('start' in value) || value['start'] === undefined) return false;
    if (!('end' in value) || value['end'] === undefined) return false;
    return true;
}

export function Sync200ResponseOneOf1ShiftsLastDayFromJSON(json: any): Sync200ResponseOneOf1ShiftsLastDay {
    return Sync200ResponseOneOf1ShiftsLastDayFromJSONTyped(json, false);
}

export function Sync200ResponseOneOf1ShiftsLastDayFromJSONTyped(json: any, ignoreDiscriminator: boolean): Sync200ResponseOneOf1ShiftsLastDay {
    if (json == null) {
        return json;
    }
    return {
        
        'start': json['start'],
        'end': json['end'],
    };
}

export function Sync200ResponseOneOf1ShiftsLastDayToJSON(json: any): Sync200ResponseOneOf1ShiftsLastDay {
    return Sync200ResponseOneOf1ShiftsLastDayToJSONTyped(json, false);
}

export function Sync200ResponseOneOf1ShiftsLastDayToJSONTyped(value?: Sync200ResponseOneOf1ShiftsLastDay | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'start': value['start'],
        'end': value['end'],
    };
}

